<template>
  <div class="mt-0" align="center">

  </div>
</template>
<script>
import axios from 'axios'
import { ecomService_dotnet } from '@/website/global'
import { DateNow, FormatInvoice, formatMoney } from '@/website/global_function'
import { header_token } from '@/website/backend/token'
import { expressService_dotnet } from '../../global'
  export default {
    components: {
      // 'barcode': VueBarcode,
      // VueQrcode
    },
    data: () => ({
      shop_id: null,
      url_callback: null
    }),
    async created () {
      this.shop_id = localStorage.getItem('shop_id')
    
      this.url_callback = window.location.href
      if(this.$route.query.url!=null){
        var path = this.$route.query.url.toString();

        window.location.assign(decodeURI(path)+"?code="+this.$route.query.code+"&shop_id="+this.$route.query.shop_id);
      }
      if(this.shop_id != null){
        await this.update_data_call_back()
      }else {
        // encode fullphat
        var url_encode = encodeURIComponent(this.url_callback)
        this.$router.push('/login?ref='+ url_encode)
      }
    },
    watch: {
    },
    methods: {
      // DateNow,
      async update_data_call_back() {
        this.loading = true
       
        let response1 = await axios.post(expressService_dotnet+'ShopeeChat/chat-callback',{
          "shopID": this.shop_id ,
          "callbackUrl": this.url_callback 
        } , { headers: header_token})
        this.loading = false
      
        this.$router.push('/connect')
        // let response = await axios.post(shopCallbackService+'shopee/callback', {
        //   'shop_id': this.shop_id,
        //   'check_init_shopee': localStorage.getItem('check_init_shopee'),
        //   'url_callback' : this.url_callback
        // })
        // if (response.data.status == 'Success') {
        //   // console.log('end');
        //    localStorage.removeItem("check_init_shopee");
        //     // this.update_data_connect()
        //     this.$router.push('/connect')
        // }
        // this.loading = false
      },

      // async update_data_connect () {
      //   let response = await axios.post(shopCallbackService+'shopee/update_data_monthlyfee', {
      //     'shop_id': localStorage.getItem('shop_id'),
      //     'staff_id' : localStorage.getItem('staff_id'),
      //     'branch_id' : localStorage.getItem('branch_id')
      //   })
      //   if (response.data.status == 'Success') {
      //     // console.log('end');
      //     console.log('update monthlyfee success');
      //   }
      //   this.loading = false
      // },
    },
  }
</script>
